/**
 * 接口文档
 *  http://api-doc-sl.inshopline.com/#/project/80/feature%2F20210907_v1.0.0/interface/56bba14304dfa69c165c640b712254c3
 */
export default {
  /** 获取枚举列表 */
  enums: '/api/commons/enums/list',
  /**根据商家ID获取仓库信息 */
  sellerExpressList: '/api/seller-express/list',
  /** 导入模板地址和更新时间 */
  templateInfo: '/api/tasks/import-info',
  /** 翻译接口 */
  translate: '/api/commons/translate',
  /** 获取商家授权仓库下所有物流渠道 */
  i18nLogisticsList: '/api/logistics/list-logistics',
  /** 获取商家授权仓库下所有物流服务商 */
  i18nLogisticsProvidersList: '/api/logistics/list-logistics-provider',

  /** 获取是否绑定了可以上传的销售平台 */
  BandSalesPlatform: '/api/stock/sync/rule/isSkip',

  //获取最新需要弹框的公告栏
  getPop: '/api/notify/get-pop',
  //查询公告列表
  notifyList: '/api/notify/list',
  //已读公告栏
  notifyRead: '/api/notify/read',
  //未读公告数接口
  notifyCount: '/api/notify/count',
  //站内信列表
  messageList: '/api/message/list',
  //站内信已读接口
  messageRead: '/api/message/read',
  //未读站内信接口
  messageCount: '/api/message/count',
  /** 同时获取商家的多个配置信息，如：地址匹配算法、币种自动转换 */
  getSellerSettings: '/api/settings/list',
  /** 更新商家配置 */
  updateSellerSetting: '/api/settings/updateSellerSetting',
  /** 获取dash开关配置（查询系统配置） */
  getDashSettings: '/api/settings/system-setting/get',
  /** 获取仓储商家基本信息，如：sellerId，warehouseSellerNo，sellerOwnerType */
  sellerBasicInfo: '/api/seller/get-basic-info',
}
